<template>
  <div class="container text-center">
    <h4 class="title text-center mb-4 mt-2">Organizer</h4>
    <div class="row justify-content-center">
      <div class="col-md-5">
        <a class="text-center" href="/"><img src="/resource_social22/img/logo_polyu.png" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">The Hong Kong Polytechnic University (PolyU)</p>
        <a href="https://polyusmart.net/" target="_blank" rel="noopener">SMART Group</a>
      </div>
      <div class="col-md-5">
        <a href="/"><img src="/resource_social22/img/logo_cuhk.png" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">The Chinese University of Hong Kong (CUHK)</p>
      </div>
      <div class="col-md-5">
        <a href="/"><img src="/resource_social22/img/logo_fudan_1.png" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">Fudan University</p>
        <a href="http://fudan-disc.com/" target="_blank" rel="noopener">DISC Lab</a>
      </div>
      <div class="col-md-5">
        <a href="/"><img src="/resource_social22/img/logo_tongji.jpg" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">Tongji University</p>
      </div>
      <div class="col-md-5">
        <a href="/"><img src="/resource_social22/img/logo_weiredian.png" height="60"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">WRD Big Data Institute</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">General Chair</h4>
    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img width="100%" v-lazy="'/resource_social22/img/organizer_huangjinhui.png'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="https://www.se.cuhk.edu.hk/people/academic-staff/prof-wong-kam-fai/"
                                       target="_blank">Kam-Fai Wong</a></p>
        <p class="">CUHK</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">Program Chair</h4>
    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_lijing.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">
          <a href="http://www4.comp.polyu.edu.hk/~jing1li/" target="_blank">Jing Li</a>
        </p>
        <p class="">PolyU</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_weizhongyu.png'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="http://www.sdspeople.fudan.edu.cn/zywei/" target="_blank">Zhongyu
          Wei</a></p>
        <p class="">Fudan</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_wanghaofen.jfif'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Haofen Wang</p>
        <p class="">Tongji</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">Organization Chair</h4>
    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_chenlei.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Lei Chen</p>
        <p class="">Fudan</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">Organization Comittee</h4>
    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_luzexin.png'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Zexin Lu</p>
        <p class="">PolyU</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_xiangrong.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Rong Xiang</p>
        <p class="">PolyU</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_wukun.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Kun Wu</p>
        <p class="">Fudan</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_dingkeyang.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Keyang Ding</p>
        <p class="">HIT</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">Advisory Comittee</h4>
    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_liqing.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="https://www4.comp.polyu.edu.hk/~csqli/" target="_blank">Qing Li</a>
        </p>
        <p class="">PolyU</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_liwenjie.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="http://www4.comp.polyu.edu.hk/~cswjli/" target="_blank">Wenjie
          Li</a></p>
        <p class="">PolyU</p>
      </div>
      <div class="col-sm-3 px-5">
        <img width="100%" v-lazy="'/resource_social22/img/organizer_huangchuren.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="http://llt.cbs.polyu.edu.hk/people/" target="_blank">Chu-Ren Huang</a></p>
        <p class="">PolyU</p>
      </div>

    </div>

    <div class="row mx-5 justify-content-center align-items-center">
      <div class="col-sm-3 px-5">
        <img width="100%" v-lazy="'/resource_social22/img/organizer_huangxuanjing.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a href="https://nlp.fudan.edu.cn/28702/list.htm" target="_blank">Xuanjing Huang</a>
        </p>
        <p class="">Fudan</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_zhoubaohua.jfif'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal"><a
            href="http://www.xwxy.fudan.edu.cn/node2/fdxwxy/n1339/n1340/n1344/n1370/n1374/u1ai112774.html"
            target="_blank">Baohua Zhou</a></p>
        <p class="">Fudan</p>
      </div>
      <div class="col-sm-3 px-5">
        <img v-lazy="'/resource_social22/img/organizer_liuyidong.jpg'" class="rounded-circle img-raised"/>
        <p class="mt-4 mb-0 font-weight-normal">Yidong Liu</p>
        <p class="">WRD</p>
      </div>
    </div>

    <h4 class="title text-center mb-4 mt-2">Organization Support</h4>
    <div class="row justify-content-center">
      <div class="col-md-5">
        <a class="text-center" href="http://shua.fudan.edu.cn/" target="_blank"><img src="/resource_social22/img/logo_shua.png" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">Shanghai-Hong Kong University Alliance</p>
      </div>
      <div class="col-md-5">
        <a href="https://www.ugc.edu.hk/eng/ugc/index.html" target="_blank"><img src="/resource_social22/img/logo_ugc.png" height="70"></a>
        <p class="font-weight-normal" style="margin-bottom: -5px">University Grants Committee</p>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "indexOrganization"
}
</script>

<style scoped>

</style>